<template>
  <main id="about-page">
    <ContentTitle :category="$t('sideMenu.ClientInventory')" :categoryIcon="'scf-patrimoine'"
      :title="$t('pages.DeviceList.EquipmentList')" />

    <div style="max-width: 100%">
      <div class="row" style="
          align-content: flex-end;
          justify-content: flex-end;
          padding-top: 10px;
        "></div>
      <div class="row">
        <div class="col-md-12" v-if="componentKey > 0">
          <!-- group panel -->

          <OdataFlexGrid :key="componentKey" :Api="{
            base: urlOdata + 'api/v1/OData/',
            // controller: 'devices?$filter=((Type%20ne%20%27Asset%27))',withoutAssets GetWithoutAssets
            controller: `devices`,
          }" :requestHeaders="gridHeaders" :FiltersDefinition="FiltersDefinition" :ColumnsDefinition="columns"
            :FilterColumns="[
              'ExternalId',
              'AlternateExternalId',
              'Manufacturer',
              'Type',
              'SubType',
              'LifeCycle',
              'Version'
            ]" :displayLang="culture" v-on:initializedGrid="gridInitialized" v-on:gridFilterChanged="gridFilterChanged"
            :GridId="'devicesGrid-v3_1'" :ExportsButtons="{
              Header: ExportsHeader,
              DataSource: ExportsDataSource,
              Events: ExportsEvents,
            }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')" v-on:format-columns="formatColumns"
            v-on:column-visibility-changed="componentKey++">
            <template #topLeftMenu>
              <ActionsDroppedDown :header="header" :dataSource="dataSource" :events="events" />
            </template>
          </OdataFlexGrid>
          <!-- END Grid -->

          <ReturnToCommonStockModal v-if="$jwt.hasRole('dm-administrator')" :isModalOpen="isModalOpen"
            @CloseModal="handleCloseModal" />
        </div>
        <loaderSpinner :loading="isLoading"></loaderSpinner>
        <p></p>
      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import MainService from "../services/MainService";
import utils from "../Utils/libraries";
import Helper from "@/Utils/Helper";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Configs from "../../configs";
import * as wijmo from "@grapecity/wijmo";
import * as wjcGrid from "@grapecity/wijmo.grid";
// import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";
import ReturnToCommonStockModal from "../components/molecules/ReturnToCommonStockModal";
import ActionsDroppedDown from "../components/molecules/ActionsDroppedDown";
import LoaderSpinner from "../components/LoadingSpinner.vue";

export default defineComponent({
  name: "CompaignList",
  inject: ["accessToken", "routePrefix", "currentScope"],
  components: {
    OdataFlexGrid,
    ContentTitle,
    ReturnToCommonStockModal,
    ActionsDroppedDown,
    LoaderSpinner,
  },
  watch: {
    currentScope: {
      handler: function (newVal) {
        this.refreshContent(newVal);
      },
      deep: true,
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScopeView);
      }
    },
    culture() {
      if (this.currentScopeView != null && this.currentScopeView !== "" && this.gridParametersLoaded)
        this.componentKey += 1;
    },
  },

  computed: {
    currentScopeView() {
      return this.preselectedScope ?? this.currentScope ?? this.$jwt.scope;
    },
    gridHeaders() {
      return {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': this.currentScopeView,
        'X-Custom-Filters': computed(() => this.headerFilters),
      };
    }
  },

  data() {
    return {
      isLoading: false,
      isModalOpen: false,
      gridParametersLoaded: false,
      header: {
        text: "Actions",
        icon: "scf-export",
      },
      dataSource: [
        {
          text: computed(() => this.$t('pages.DeviceImportList.Source.ReturnToCommunStock')),
          method: "returnToCommonStock",
          icon: "scf-export",
        },
      ],
      events: [
        { returnToCommonStock: this.handleReturnToCommonStock, }
      ],
      componentKey: 0,
      mainService: new MainService(this.$jwt.token, this.currentScope),
      deviceTypeValueFilter: null,
      deviceSubTypeValueFilter: null,
      deviceManufacturerFilter: null,
      config: Configs,
      doneTheStuff: false,
      isFirstLoad: true,
      theGrid: null,
      culture: computed(() => this.$i18n.locale),
      screenName: computed(() => this.$t('pages.DeviceList.EquipmentList')),
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      filter: null,
      valueTypes: [
        {
          id: "Transmitter2",
          label: "Transmitter2",
        },
      ],
      FiltersDefinition: [
        {
          binding: "Version",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "AlternateExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Manufacturer",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: computed(() => this.deviceManufacturerFilter),
        },
        {
          binding: "Type",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: computed(() => this.deviceTypeValueFilter),
        },
        {
          binding: "SubType",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: computed(() => this.deviceSubTypeValueFilter),
        },
        {
          binding: "LifeCycle",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "AttachedAssociated",
              label: computed(() =>
                this.getTraductionLifeCycle("AttachedAssociated")
              ),
            },
            {
              id: "Attached",
              label: computed(() => this.getTraductionLifeCycle("Attached")),
            },
            {
              id: "AttachedInStock",
              label: computed(() =>
                this.getTraductionLifeCycle("AttachedInStock")
              ),
            },
            {
              id: "Associated",
              label: computed(() => this.getTraductionLifeCycle("Associated")),
            },
            {
              id: "Unattached",
              label: computed(() => this.getTraductionLifeCycle("Unattached")),
            },
            {
              id: "UnattachedInStock",
              label: computed(() =>
                this.getTraductionLifeCycle("UnattachedInStock")
              ),
            },
            {
              id: "UnexpectedLifeCycleState",
              label: computed(() =>
                this.getTraductionLifeCycle("UnexpectedLifeCycleState")
              ),
            },
          ],
        },
      ],
      ActionsBtn: [
        {
          text: computed(() => this.$t('pages.DeviceImportList.Source.ReturnToCommunStock')),
          method: "returnToCommonStock",
          icon: "scf-csv",
        },
      ],
      ExportsHeader: {
        text: "Exports",
        icon: "scf-export",
      },
      ExportsDataSource: [
        {
          text: "Export as Csv",
          method: "exportCsv",
          icon: "scf-csv",
        },
        {
          text: "Export as Excel",
          method: "exportExcel",
          icon: "scf-excel",
        },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      ManufacturersSource: null,
      loading: true,
      startLoadingTime: 0,
      rowsCount: 0,
      columns: [
        {
          width: "80*",
          header: computed(() => this.$t("pages.DeviceList.columns.Id")),
          binding: "Id",
          dataType: 2,
          visible: false,
          isTechnicalColumn: true,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.DeviceList.columns.ExternalId")
          ),
          binding: "ExternalId",
          dataType: 1,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.DeviceList.columns.AlternateExternalId")
          ),
          binding: "AlternateExternalId",
          dataType: 1,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.Version")
          ),
          binding: "Version",
          dataType: 1,
        },
        {
          width: "60*",
          header: computed(() =>
            this.$t("pages.DeviceList.columns.Manufacturer")
          ),
          binding: "Manufacturer",
          dataType: 1,
        },

        {
          width: "120*",
          header: computed(() => this.$t("pages.DeviceList.columns.Type")),
          binding: "Type",
          dataType: 1,
        },
        {
          width: "80*",
          header: computed(() => this.$t("pages.DeviceList.columns.SubType")),
          binding: "SubType",
          dataType: 1,
        },
        {
          width: "170*",
          header: computed(() => this.$t("pages.DeviceList.columns.LifeCycle")),
          binding: "LifeCycle",
          dataType: 1,
        },

        {
          width: "50*",
          header: "Actions",
          dataType: 0,
        },
      ],
      exportRoot:
        Configs.value("VUE_APP_WEBAPI") + `api/v1/OData/devices/export?`,
    };
  },
  methods: {
    handleCloseModal() {
      this.isModalOpen = false;
    },

    handleReturnToCommonStock() {
      this.isModalOpen = true;
    },

    gridFilterChanged(data) {
      this.latestDataState = data;
    },
    exportExcel() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=excel`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel`;
      }


      this.isLoading = true;
      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(this.screenName, type, "xlsx", response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    exportCsv() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=csv`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv`;
      }


      this.isLoading = true;
      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(this.screenName, type, "csv", response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], {
        type: "application/vnd.ms-excel",
      });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },
    gridInitialized(flexgrid) {
      let self = this;

      this.theGrid = flexgrid;

      flexgrid.hostElement.addEventListener("click", function (e) {
        let action = e.target.getAttribute("action-type");
        if (!action) {
          return;
        }

        var hitTest = flexgrid.hitTest(e);
        var data = flexgrid.rows[hitTest.row].dataItem;

        self.$router.push({
          path: `/DmPortal/equipmentdetail/${this.currentScopeView}/${data.Type}/${data.Id}`,
        });
      });
    },
    CreateTypeFilterDefinitionObject(list) {
      let obj = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i] == null) {
          obj.push({
            id: "nullValueFilter",
            label: this.$t("common.nothing"),
          });
          continue;
        }

        if (this.translationExists(`pages.DeviceList.Type.${list[i]}`)) {
          obj.push({
            id: list[i],
            label: computed(() => this.$t(`pages.DeviceList.Type.${list[i]}`)),
          });
        } else {
          obj.push({
            id: list[i],
            label: list[i],
          });
        }
      }

      return obj;
    },
    CreateSubTypeFilterDefinitionObject(list) {
      let obj = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i] == null) {
          obj.push({
            id: "nullValueFilter",
            label: this.$t("common.nothing"),
          });
          continue;
        }

        if (
          this.translationExists(`pages.DeviceList.SubType.${list[i]}`)
        ) {
          obj.push({
            id: list[i],
            label: computed(() =>
              this.$t(`pages.DeviceList.SubType.${list[i]}`)
            ),
          });
        } else {
          obj.push({
            id: list[i],
            label: list[i],
          });
        }
      }

      return obj;
    },

    CreateManufacturerFilterDefinitionObject(list) {
      let obj = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i] == null) {
          obj.push({
            id: "nullValueFilter",
            label: this.$t("common.nothing"),
          });
          continue;
        }

        obj.push({
          id: list[i],
          label: list[i],
        });
      }

      return obj;
    },
    formatColumns: function (s, e) {
      const flex = s;
      if (e.panel == flex.cells) {
        if (flex.rows[e.row].dataItem.name) return;
        if (flex.columns[e.col].header == "Actions") {
          if (s.rows[e.row].dataItem.Type != "Asset") {
            const prefix = Helper.ComputeRoutePrefix(this.routePrefix);

            e.cell.innerHTML =
              '<a class="scf-searchPlus"  target="_blank" style="color:#6095D6;text-decoration: none;" href="' +
              prefix +
              "/DmPortal/equipmentdetail/" +
              this.currentScopeView +
              "/" +
              s.rows[e.row].dataItem.Type +
              "/" +
              s.rows[e.row].dataItem.Id +
              '"></a>';
          }

          //  e.cell.innerHTML =
          //     '<i><svg style="color:blue;cursor:pointer;" action-type="show" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg></i>';
        } else if (flex.columns[e.col].binding == "Description") {
          if (e.cell.textContent.trim().length > 20) {
            e.cell.innerHTML = wijmo.format(
              '<i action-type-description="showDescriptionInSwal">' +
              this.substringIfGreaterThanTweenty(e.cell.textContent.trim()) +
              "</i>",
              s.rows[e.row].dataItem
            );
          } else {
            e.cell.innerHTML = wijmo.format(e.cell.textContent.trim());
          }
        } else if (flex.columns[e.col].binding == "StatusEnum") {
          e.cell.innerHTML = wijmo.format(
            this.getTraductionState(e.cell.textContent.trim()),
            s.rows[e.row].dataItem
          );
        }
      }
    },
    formatGrid: function (s, e) {
      if (
        s.columns[e.col].header == "Action" &&
        e.panel.cellType == wjcGrid.CellType.Cell
      ) {
        // e.cell.innerHTML =
        //   '<i><svg action-type="show" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg></i>';
        e.cell.innerHTML =
          '<i class="scf-search" style="cursor:pointer"><a href="#"></a></i>';
      }
    },
    getTraductionState: function (e) {
      if (this.translationExists(`pages.DeviceList.State.${e}`))
        return this.$t(`pages.DeviceList.State.${e}`);
      return e;
    },
    getTraductionLifeCycle: function (e) {
      if (this.translationExists(`pages.LifeCycle.${e}`))
        return this.$t(`pages.LifeCycle.${e}`);
      return e;
    },
    translationExists(e) {
      return typeof this.$tm(e) == "string";
    },
    showmessage() {
      Swal.fire("functionality not yet specified", "", "info");
    },
    showDescriptionInSwal(e) {
      Swal.fire("", e, "");
    },
    substringIfGreaterThanTweenty(e) {
      if (e.length > 20) {
        return e.substring(0, 17).concat("", "...");
      } else return e;
    },
    async initFilterParameters() {
      await this.mainService
        .getFilterParameters(this.gridHeaders)
        .then((response) => {
          if (
            typeof response != "undefined" &&
            response != null &&
            response.length != null &&
            response.length > 0
          ) {
            this.deviceTypeValueFilter = this.CreateTypeFilterDefinitionObject([
              ...new Set(response.map((item) => item.type)),
            ]);
            this.deviceSubTypeValueFilter =
              this.CreateSubTypeFilterDefinitionObject([
                ...new Set(response.map((item) => item.subType)),
              ]);
            this.deviceManufacturerFilter =
              this.CreateManufacturerFilterDefinitionObject([
                ...new Set(response.map((item) => item.manufacturer)),
              ]);
          }
        })
        .then(() => {
          this.gridParametersLoaded = true;
          this.componentKey++;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetFirstLoad() {
      sessionStorage.removeItem('isFirstLoad');
    },
    refreshContent(newScopeVal) {
      if (newScopeVal && this.componentKey < 1) {
        this.mainService = new MainService(this.$jwt.token, newScopeVal);
        this.initFilterParameters();
        if (this.gridParametersLoaded) {
          this.componentKey += 1;
        }
      }
    }

  },
  mounted() {
    if (!sessionStorage.getItem('isFirstLoad')) {
      this.isFirstLoad = true;
      sessionStorage.setItem('isFirstLoad', 'true');
    } else {
      this.isFirstLoad = false;
    }

    window.addEventListener('beforeunload', this.resetFirstLoad);



    if (!this.isFirstLoad || this.currentScope) {
      this.refreshContent(this.currentScope);
    }
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.resetFirstLoad);
  }
});
</script>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

#about-page {
  font-family: "D-DIN" !important;
}
</style>

<style scoped src="../assets/css/campaignList.css"></style>